export default function () {
  this.get('https://unpkg.com/*', this.passthrough);
}
